import React from 'react'
import styles from './ConfirmationCard.module.css'

export interface ConfirmationData {
    confirm: boolean
    message: string
    operation: string
    confirmationFlag: boolean
    requestId: string
    timestamp: string
    user: string
}

export interface ConfirmationCardProps {
    message: string
    data: ConfirmationData
    operation: string
    title?: string
    onConfirm: (operation: string, data: any) => void
}

const ConfirmationCard: React.FC<ConfirmationCardProps> = ({ 
    message, 
    data, 
    operation,
    title,
    onConfirm 
}) => {
    const handleConfirm = () => {
        // Pass the entire data object which now contains all confirmation info
        onConfirm(operation, data)
    }

    return (
        <div className={`${styles.confirmationCard} ai-message`}>
            {/* Message text */}
            
            
            {/* Data display */}
            <div className={styles.dataCard}>
                {title && (
                    <h4 className="title is-6 mb-3">{title}</h4>
                )}
                <pre>
                    {message}
                </pre>
                {/* <div className={styles.dataGrid}>
                    {Object.entries(data).map(([key, value]) => (
                        <div key={key} className={styles.dataField}>
                            <span className={styles.fieldLabel}>{key}:</span>
                            <span className={styles.fieldValue}>
                                {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                            </span>
                        </div>
                    ))}
                </div> */}
            </div>
            
            {/* Confirmation button */}
            <div className={styles.confirmButton}>
                <button
                    className="button is-primary is-small"
                    onClick={handleConfirm}
                >
                    Proceed with {operation}
                </button>
            </div>
        </div>
    )
}

export default ConfirmationCard 